export default "__VITE_ASSET__CeaYZxbo__"